'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { KOALA } from 'HubStyleTokens/colors';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { hidden } from '../../utils/propTypes/decorators';
import UIAbstractDropdown from './UIAbstractDropdown';
/**
 * Keeps track of the effective placement and sets arrowColor accordingly.
 */

export default class UIAbstractDropdownWithSearchbox extends Component {
  static getDerivedStateFromProps(props, state) {
    let derivedState = null; // If the placement prop is reset, clear our internal override.

    if (props.placement !== state.prevPlacement) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevPlacement: props.placement
      });
    }

    if (props.open && !state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        placement: null,
        prevOpen: props.open
      });
    } else if (props.open !== state.prevOpen) {
      derivedState = Object.assign({}, derivedState, {
        prevOpen: props.open
      });
    }

    return derivedState;
  }

  constructor(props) {
    super(props);

    this.handleChangePlacement = evt => {
      const {
        onChangePlacement
      } = this.props;
      const {
        newPlacement
      } = evt;

      if (this.state.placement !== newPlacement) {
        this.setState({
          placement: newPlacement
        });
      }

      if (onChangePlacement) onChangePlacement(evt);
    };

    this.state = {
      placement: null,
      prevPlacement: props.placement,
      prevOpen: props.open
    };
  }

  render() {
    const _this$props = this.props,
          {
      buttonUse,
      dropdownClassName,
      hasSearchbox,
      placement
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["buttonUse", "dropdownClassName", "hasSearchbox", "placement"]);

    const {
      placement: placementState
    } = this.state;
    const defaultPlacement = buttonUse.match(/link|transparent/) ? 'bottom' : 'bottom right';
    const computedPlacement = placementState || placement || defaultPlacement;
    const arrowAtBottom = computedPlacement.includes('bottom');
    const arrowAtTop = computedPlacement.includes('top');
    const computedArrowColor = hasSearchbox && arrowAtBottom ? KOALA : null;
    const computedDropdownClassName = classNames(dropdownClassName, hasSearchbox && [arrowAtBottom && 'p-y-0', arrowAtTop && 'p-top-0']);
    return /*#__PURE__*/_jsx(UIAbstractDropdown, Object.assign({}, rest, {
      arrowColor: computedArrowColor,
      buttonUse: buttonUse,
      dropdownClassName: computedDropdownClassName,
      onChangePlacement: this.handleChangePlacement,
      placement: computedPlacement
    }));
  }

}
UIAbstractDropdownWithSearchbox.propTypes = Object.assign({}, UIAbstractDropdown.propTypes, {
  arrowColor: hidden(UIAbstractDropdown.propTypes.arrowColor),
  hasSearchbox: PropTypes.bool.isRequired
});
UIAbstractDropdownWithSearchbox.defaultProps = UIAbstractDropdown.defaultProps;
UIAbstractDropdownWithSearchbox.displayName = 'UIAbstractDropdownWithSearchbox';